import { render, staticRenderFns } from "./CreateMontageAppointment.vue?vue&type=template&id=05dcecbc&scoped=true"
import script from "./CreateMontageAppointment.vue?vue&type=script&lang=js"
export * from "./CreateMontageAppointment.vue?vue&type=script&lang=js"
import style0 from "./CreateMontageAppointment.vue?vue&type=style&index=0&id=05dcecbc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05dcecbc",
  null
  
)

export default component.exports